module Meevo.Plugins.FloorLocation {
  "use strict";

  /**
  * Main Section of FloorLocation 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.FloorLocation> {
    /**
    * Base class override which defines what a DEFAULT model looks like.
    */
      createSectionModelInstance(postAdd: (data: any) => any): void {
          this.dataService.getTemplate(this.baseEndpoint).then((data) => {
          this.model = data;
        });
    }
  }
}